import { Injectable, Injector } from "@angular/core";
import { PreguntaDTO, RespuestaUsuario } from "@DTOS";
import { Respuesta } from "../../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { Store } from "@ngxs/store";
import { CacheRespuestas } from "../CacheRespuestas";
import { CloudData } from "angular-tag-cloud-module";
import { ObtenerRespuestas } from "./ObtenerRespuestas";

@Injectable({
    providedIn: "root"
})
export class ObtenerRespuestasSinComparativa extends ObtenerRespuestas {
    constructor(store: Store, cacheRespuestas: CacheRespuestas, injector: Injector) {
        super(store, cacheRespuestas, injector);
    }

    public async obtenerRespuestas(
        pregunta: PreguntaDTO, respuestas: RespuestaUsuario[]
    ): Promise<Respuesta[] | CloudData[]> {
        return await this.obtenerRespuestasPregunta(pregunta, respuestas);
    }
}
